
import React, { useContext } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";

const MENU = [
  {
    label: "Certificate Register",
    route: "/assets/certificate-management",
    perms: ["ASSET_CERTIFICATES", "WMS_DASHBOARD"],
    icon: "fas fa-certificate",
  },
];

export default function CertificateSidebar({ expanded, onToggle }) {
  const { permissions } = useContext(AuthContext);
  const location = useLocation();

  const canView = (keys) =>
    keys.some((key) => permissions?.[key]?.view === true);

  return (
    <aside
      style={{
        width: expanded ? "260px" : "64px",
        transition: "width 0.22s ease",
        background: "#1f2937",
        color: "#fff",
        minHeight: "100vh",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 100,
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          height: 56,
          display: "flex",
          alignItems: "center",
          justifyContent: expanded ? "space-between" : "center",
          padding: expanded ? "0 12px" : 0,
          borderBottom: "1px solid #374151",
        }}
      >
        {expanded && <strong>CERTIFICATES</strong>}

        <button
          type="button"
          aria-label="Toggle Certificate Management sidebar"
          onClick={() => onToggle(!expanded)}
          style={{
            background: "none",
            border: "none",
            color: "#9ca3af",
            cursor: "pointer",
          }}
        >
          <i className="fas fa-bars" />
        </button>
      </div>

      <Link
        to="/dashboard"
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          margin: 12,
          padding: "10px 12px",
          borderRadius: 999,
          background: "#4f46e5",
          color: "#fff",
          textDecoration: "none",
          justifyContent: expanded ? "flex-start" : "center",
        }}
      >
        <i className="fas fa-home" />
        {expanded && <span>Back to Dashboard</span>}
      </Link>

      <nav style={{ padding: "4px 0" }}>
        {MENU.map((item) => {
          if (!canView(item.perms)) return null;

          const active =
            location.pathname === item.route ||
            location.pathname.startsWith(`${item.route}/`);

          return (
            <NavLink
              key={item.route}
              to={item.route}
              end
              title={!expanded ? item.label : undefined}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: expanded ? "10px 14px" : "10px 0",
                justifyContent: expanded ? "flex-start" : "center",
                color: active ? "#fff" : "#cbd5f5",
                background: active ? "#374151" : "transparent",
                textDecoration: "none",
                fontSize: 14,
              }}
            >
              <i className={item.icon} />
              {expanded && <span>{item.label}</span>}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
